import React from 'react';
import { useHistory } from "react-router-dom";
import { ReactComponent as Logo } from 'assets/images/logo.svg';
import { HEADER_LOGO_EXTRA_WEBSITE } from 'utils/Config';

const LogoComponent = ({
  isMobile,
  isCenter,
}) => {
  const history = useHistory();

  const logoOnClick = () => {
    if (HEADER_LOGO_EXTRA_WEBSITE) {
      window.open(HEADER_LOGO_EXTRA_WEBSITE, "_blank", "noopener noreferrer");
      return;
    };
    history.push('/home');
  };

  if (!isMobile) {
    return (
      <img
        className="header-logo web-header-logo"
        src="/logo/logo_mobile@3x.png"
        onClick={logoOnClick} />
    )
  }

  return (
    <div className={`header-logo-container mobile-header-logo ${isCenter ? "header-logo-center" : ""}`}>
      <img
        className="header-logo"
        src="/logo/logo_mobile@3x.png"
        onClick={logoOnClick}
      />
    </div>
  );
};


export default LogoComponent;
